import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import useAuth from "../hooks/useAuth";

const AdminRoutes = () => {
  const { auth, user } = useAuth();
  if (!auth.token) {
    return <Navigate to="/login" />;
  }
  if (!user.admin) {
    return <Navigate to="/" />;
  }
  return <Outlet />;
};

export default AdminRoutes;
